import React from 'react';
import Heroarea from './Heroarea';

const Home = () => {
    return (
        <div>
            <Heroarea></Heroarea>
        </div>
    );
};

export default Home;